import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=57379418"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57379418')) {
      api.createRecord('57379418', component.options)
    } else {
      api.reload('57379418', component.options)
    }
    module.hot.accept("./Record.vue?vue&type=template&id=57379418", function () {
      api.rerender('57379418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/Record.vue"
export default component.exports